import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const setUserBenefitEndDate = ({ benefitId, newEndDate }) =>
  call(websocketFetch, 'set_user_benefit_end_date', {
    user_benefit_id: benefitId,
    grace_period_start_date: newEndDate,
  });
